module.exports = __webpack_public_path__ + "media/images/subject_img/ZOOLOGY-82be34e4b5c7c5d36667600c9d5d3b98.jpg";